module.exports = "<router-outlet></router-outlet>\n<app-footer *ngIf=\"!isSeguros\"></app-footer>"